import { z } from 'zod/v4';

// Suppose you have UserAttribute as above
export const UserAttributeDTO = z.object({
  value_schema: z.any(),
  modifiers: z.object({
    required: z.boolean().optional(),
    blocked: z.boolean().optional(),
  }),
});
export type UserAttribute = z.infer<typeof UserAttributeDTO>;

// For the attribute_values entries
export const UserAttributeInstanceDTO = z.object({
  value_schema: z.any(),
  modifiers: UserAttributeDTO.shape.modifiers,
  value: z.any(),
  attribute_name: z.string(),
});
export type UserAttributeInstance = z.infer<typeof UserAttributeInstanceDTO>;

// Password DTOs
export const UserSetPasswordRequestDTO = z.object({
  new_password: z.string(),
});
export type UserSetPasswordRequest = z.infer<typeof UserSetPasswordRequestDTO>;

export const UserChangePasswordRequestDTO = UserSetPasswordRequestDTO.extend({
  old_password: z.string(),
});
export type UserChangePasswordRequest = z.infer<
  typeof UserChangePasswordRequestDTO
>;

// Main user schemas
export const UserDTO = z.object({
  id: z.string(),
  name: z.string().nullish(),
  surname: z.string().nullish(),
  patronymic: z.string().nullish().optional(),
  login: z.string(),
  language: z.string(),
  email: z.string().nullish().optional(),
  status: z.string().default('active').optional(),
  avatar: z.string().nullish(),
  ldap_id: z.uuid().nullish().optional(),
  sessions_max_count: z.number().default(1).optional(),
  attribute_values: z.record(z.string(), UserAttributeInstanceDTO),
  is_password_expired: z.boolean().optional(),
  connected_idps: z.array(z.string()).optional(),
  connected_ldaps: z.array(z.string()).optional(),
  has_active_api_token: z.boolean().optional(),
});
export type User = z.infer<typeof UserDTO>;

export const UserBriefDTO = UserDTO.omit({ attribute_values: true });
export type UserBrief = z.infer<typeof UserBriefDTO>;

export const CreateUserDTO = UserDTO.omit({
  id: true,
  language: true,
  name: true,
  surname: true,
  patronymic: true,
  email: true,
}).extend({
  password: z.string(),
});

export const UpdateUserDTO = UserDTO.pick({
  language: true,
  attribute_values: true,
});
export type UpdateUser = z.infer<typeof UpdateUserDTO>;
export type CreateUser = z.infer<typeof CreateUserDTO>;